import { QueryClient } from "@tanstack/react-query";

/**
 * QueryClient i vetem i aplikacionit; eksportimi lejon pastrim cache-i ne logout global.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
